import React, { Children, Component } from "react";
import Navigation from "../../components/Navigation";
import { getObjectUseCase, upsertUseCase } from "../../usecases/object";
import JobDescriptionPresenter from "./JobDescriptionPresenter";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";
import moment from "moment";
import { signOutUseCase } from "../../usecases/user";

class JobDescription extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      object: {},
      advanced: false,
      progress: false,
      quantity: 1,
    };
    this.presenter = new JobDescriptionPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      getObjectUseCase(),
      signOutUseCase()
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  getCollectionName() {
    return this.props.params.collectionname;
  }
  getSelectedItems() {
    return this.state.selected;
  }
  onclickApplyNow() {
    this.presenter.onClickApplyNow();
  }
  goBack() {
    return window.history.back();
  }

  logout() {
    this.presenter.onClickSignOut();
  }

  render() {
    const object = this.state.object;
    const objectId = this.getObjectId();
    return (
      <>
        <Navigation logout={this.logout.bind(this)} />
        <div className="py-5 px-3 p-md-3 p-md-5 mt-5">
          <div className="bg-white p-3 p-md-4 rounded-3">
            <div className="d-flex flex-column gap-3">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                <div className="d-flex gap-3 align-items-start">
                  <p
                    className="cursor-pointer m-0"
                    onClick={this.goBack.bind(this)}
                  >
                    <i
                      className="bi bi-arrow-left fs-4"
                      style={{ color: "#303030CC" }}
                    ></i>
                  </p>
                  <div>
                    <h3 className="fw-bold fs-4" style={{ color: "#256F22" }}>
                      {object?.positionTitle}
                    </h3>
                    <p className="m-0" style={{ color: "#30303080" }}>
                      Posted{" "}
                      {object?.created
                        ? `${moment(object?.created).fromNow()}`
                        : ""}
                    </p>
                  </div>
                </div>

                <button
                  className="btn text-white mt-3 mt-md-0 fw-bold p-3"
                  style={{ backgroundColor: "#E09552" }}
                  onClick={this.onclickApplyNow.bind(this)}
                >
                  Apply Now
                </button>
              </div>

              <div className="row gy-4 mt-2">
                <div className="col-12 col-lg-3">
                  <div className="px-2 px-lg-4 py-3">
                    <div>
                      <p className="fw-bold m-0" style={{ color: "#303030" }}>
                        Date Posted:
                      </p>
                      <p style={{ color: "#30303080" }}>
                        {object?.created
                          ? moment(object?.created).format("MMMM D, YYYY")
                          : ""}
                      </p>
                    </div>
                    <div>
                      <p className="fw-bold m-0" style={{ color: "#303030" }}>
                        Deadline of Application:
                      </p>
                      <p style={{ color: "#30303080" }}>
                        {object?.deadline
                          ? moment(object?.deadline).format("MMMM D, YYYY")
                          : ""}
                      </p>
                    </div>
                    <div>
                      <p className="fw-bold m-0" style={{ color: "#303030" }}>
                        Slots available:
                      </p>
                      <p style={{ color: "#6D9E5F" }}>
                        {object?.slotVacancy} slots
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-8">
                  <div className="d-flex flex-column gap-3">
                    <div className="d-flex gap-3 align-items-center">
                      <div className="shadow-sm px-3 py-2 rounded-2 bg-white">
                        <i
                          className="bi bi-info-circle-fill fs-3"
                          style={{ color: "#D18237" }}
                        ></i>
                      </div>
                      <p
                        className="fw-bold fs-5 m-0"
                        style={{ color: "#E09552" }}
                      >
                        Job Description
                      </p>
                    </div>
                    <p style={{ color: "#303030", fontSize: "1.1rem" }}>
                      {object?.jobDescription
                        ?.split("\n")
                        .map((line, index) => (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        ))}
                    </p>
                  </div>

                  <div className="d-flex flex-column gap-3 mt-4">
                    <div className="d-flex gap-3 align-items-center">
                      <div className="shadow-sm px-3 py-2 rounded-2 bg-white">
                        <i
                          className="bi bi-briefcase-fill fs-3"
                          style={{ color: "#D18237" }}
                        ></i>
                      </div>
                      <p
                        className="fw-bold fs-5 m-0"
                        style={{ color: "#E09552" }}
                      >
                        Qualification Standards
                      </p>
                    </div>
                    <p style={{ color: "#303030", fontSize: "1.1rem" }}>
                      {object?.qualificationStandard
                        ?.split("\n")
                        .map((line, index) => (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        ))}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(JobDescription);
